// 默认选中的tab code
export var DEFAULT_TAB_CODE = 99;
export var PLATFORM_OBJ = {
  'merchant': 4,
  // 商家PC
  'llsp': 5 // 服务商PC
};

export var RECEIVER_SUBJECT_OBJ = {
  'merchant': 1,
  'llsp': 2
};
export var APPLICATION_ID = {
  'merchant': 1,
  'llsp': 2
};

// 固定为4，表示商家PC类型
export var PLATFORM = 4;

// 滚动分页初始页
export var DEFAULT_CURRENT_PAGE = '0';

// className 前缀
export var STYLE_PREFIX = 'ks-lfe-mc_';

// 没有更多了
export var NO_MORE = 'no_more';